import Swiper, { EffectCreative, Pagination } from 'swiper'

Swiper.use([EffectCreative, Pagination])

export default function PressSliders () {
  const PRESS_SLIDER_WRAPPERS = document.querySelectorAll('.mtt-press-slider')

  if (PRESS_SLIDER_WRAPPERS.length) {
    for (let i = 0; i < PRESS_SLIDER_WRAPPERS.length; i++) {
      const PRESS_SLIDER_WRAPPER = PRESS_SLIDER_WRAPPERS[i]
      const SLIDER = new PressSlider(PRESS_SLIDER_WRAPPER)
      SLIDER.init()
    }
  }
}

class PressSlider {
  constructor (wrapper) {
    this.wrapper = wrapper
    this.slider = this.wrapper.querySelector('.swiper')

    this.init = () => {
      this.addSlider()
    }
  }

  addSlider () {
    if (this.slider) {
      this.swiper = new Swiper(this.slider, {
        direction: 'horizontal',
        slidesPerView: 1.4,
        watchOverflow: true,
        spaceBetween: 8,
        centeredSlides: true,
        centerInsufficientSlides: false,
        loop: true,
        slideToClickedSlide: true,
        breakpoints: {
          600: {
            spaceBetween: 20,
            slidesPerView: 1.6
          },
          750: {
            direction: 'horizontal',
            spaceBetween: 20,
            slidesPerView: 2,
          },
          1201: {
            direction: 'vertical',
            spaceBetween: 20,
            slidesPerView: 2
          },
        },
        navigation:  {
          nextEl: '.mtt-arrow--next',
          prevEl: '.mtt-arrow--prev'
        },
        on: {
          slideChange: (swiper) => {
            this.changeSlide(swiper.realIndex)
          },
        }
      })
    }
  }

  changeSlide (slideIndex) {
    const ACTIVE_SLIDE = this.wrapper.querySelector('.mtt-press-slider__active-slide--container.active')
    const NEXT_ELEMENT = this.wrapper.querySelector('.mtt-press-slider__active-slide--container[data-id="'+slideIndex+'"]')
    ACTIVE_SLIDE.classList.remove('active')
    NEXT_ELEMENT.classList.add('active')
  }
}